/**
 * Customer session storage (distinct from portal_token used by course-side
 * users). Stored under its own localStorage key so a course admin logged into
 * the portal and a golfer logged into their customer account don't collide.
 */
import axios from 'axios'

const KEY = 'customer_token'

export function getCustomerToken() {
  return localStorage.getItem(KEY) || null
}

export function setCustomerToken(t) {
  if (t) localStorage.setItem(KEY, t)
  else localStorage.removeItem(KEY)
}

export function clearCustomerSession() {
  localStorage.removeItem(KEY)
}

// A dedicated axios instance for customer-facing endpoints. Uses the public
// mounting path (no cms_users auth) and attaches the customer token when set.
// VITE_API_ORIGIN required on prod where the SPA host doesn't proxy /api/* —
// without it, axios hits stayplay.integolf.com/api/... and gets back the
// SPA index.html instead of JSON.
const _apiOrigin = import.meta.env.VITE_API_ORIGIN || window.location.origin
export const customerApi = axios.create({
  baseURL: `${_apiOrigin}/api/public/play-stay`,
  headers: { 'Content-Type': 'application/json' },
})

customerApi.interceptors.request.use((config) => {
  const token = getCustomerToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})
